import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

type ChangePasswordData = {
  current_password: string;
  new_password: string;
}

type ChangePasswordResponse = {
  message?: string;
  detail?: string;
}

export const changePassword = async (data: ChangePasswordData, user_id: string) => {
  const authToken = getCookie("auth_token");
  const response = await fetch(`${BASE_URL_API}/users/${user_id}/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json() as ChangePasswordResponse;
    throw new Error(error.detail);
  }

  return { message: "Senha alterada com sucesso" } as ChangePasswordResponse;
};